export const ADMIN_ROLES = ['super_admin', 'admin', 'moderator'] as const;
export type AdminRole = (typeof ADMIN_ROLES)[number];

export const ADMIN_STATUSES = ['active', 'suspended'] as const;
export type AdminStatus = (typeof ADMIN_STATUSES)[number];

/** The authenticated admin principal returned by the API. */
export interface PublicUser {
  id: string;
  name: string;
  email: string;
  role: AdminRole;
  status: AdminStatus;
  createdAt: string;
  updatedAt: string;
}

export const ADMIN_ROLE_LABELS: Record<AdminRole, string> = {
  super_admin: 'Super Admin',
  admin: 'Admin',
  moderator: 'Moderator',
};
